var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "bg-black bg-opacity-40 justify-center items-center absolute inset-0 lg:grid z-10",
    },
    [
      _c(
        "div",
        {
          staticClass:
            "w-full h-full rounded bg-white p-3 flex flex-col gap-y-3 relative overflow-hidden lg:w-960 lg:h-4/5 lg:p-10 lg:gap-y-5",
        },
        [
          _c(
            "div",
            { staticClass: "flex justify-between items-center" },
            [
              _c("span", { staticClass: "text-lg font-bold" }, [
                _vm._v(_vm._s(_vm.$t("link.list.title"))),
              ]),
              _c("GrmCloseBtn", { on: { click: _vm.onClose } }),
            ],
            1
          ),
          _c(
            "GrmBtn",
            { staticClass: "relative", on: { click: _vm.onCreateURLShare } },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.isCreateURLShare
                      ? _vm.$t("link.list.add.cancel")
                      : _vm.$t("link.list.add.title")
                  ) +
                  " "
              ),
            ]
          ),
          _c(
            "div",
            {
              staticClass:
                "min-h-0 flex-1 -mx-3 px-3 overflow-y-auto lg:-mx-10 lg:px-10",
            },
            [
              _c(
                "div",
                { staticClass: "h-full flex flex-col relative" },
                [_c("URLShareTable")],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }